export const iconFontAwesomeMedicalHealthDisease = (
	<i className="fa-solid fa-disease"></i>
);
